/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import $ from 'jquery';
import BaseControl from 'scripts/base-control';
import get from 'lodash/get';
import DomEventsManager from 'scripts/dom-events-manager';
import appContext from 'scripts/app-context';
import dtm from 'scripts/services/dtm';

export const ChampNavigation = BaseControl.extend({
    invokableAction: false,

    init: function () {
        this._super();

        this.screen = this.options.appContext.model.screen;

        this.navItemsMap = [];
        this.navMoreItemsMap = [];
        this.$header = this.$element.find('.s-header');
        this.$mainNavigation = this.$element.find('.s-header .js-main-navigation');
        this.$logo = this.$element.find('.s-header .js-logo');
        this.$navigation = this.$element.find('.s-header .js-navigation');
        this.$moreItem = this.$element.find('.s-header .js-nav-item-more');
        this.$navItemsWrapper = this.$element.find('.s-header .js-navigation-items-wrapper');
        this.$element.find('.s-header .js-nav-item').each((index, el) => {
            $(el).data('index', index).attr('data-index', index);
            this.navItemsMap.push(el);
        });
        this.$element.find('.s-header .js-more-item').each((index, el) => this.navMoreItemsMap.push(el));

        (this.screen.attr('screenSize') === 'large' || this.screen.attr('screenSize') === 'extra-large') && this.checkNavigationItemsCount();

        DomEventsManager.subscribe(this);
    },

    isObject: function (obj) {
        var type = typeof obj;
        return type === 'function' || type === 'object' && !!obj;
    },

    onLayout: function (screen) {
        this.expandedItemIndex != null && this.itemClick(this.expandedItemIndex);
        screen === 'large' || screen === 'extra-large' ? this.bindDesktopEvents() : this.bindMobileEvents();
    },

    bindDesktopEvents: function () {

        if (this.bindindDesktopEvents) {
            return;
        }

        if (this.bindindMobileEvents) {
            this.bindindMobileEvents.destroy();
            this.bindindMobileEvents = null;
        }

        const desktopEventsControl = this.can.Control.extend(this.desktopEvents(this)[0]);
        this.bindindDesktopEvents = new desktopEventsControl(this.$element);
    },

    bindMobileEvents: function () {
        if (this.bindindMobileEvents) {
            return;
        }

        if (this.bindindDesktopEvents) {
            this.bindindDesktopEvents.destroy();
            this.bindindDesktopEvents = null;
        }

        const mobileEventsControl = this.can.Control.extend(this.mobileEvents(this)[0]);
        this.bindindMobileEvents = new mobileEventsControl(this.$element);
    },

    onWindowResize: function () {
        if (this.screen.attr('screenSize') === 'large' || this.screen.attr('screenSize') === 'extra-large') this.checkNavigationItemsCount();
    },

    onScreenOrientation() {
        // Force repaint on iPad for the correct menu display
        this.$header.hide().show(0);
    },

    checkNavigationItemsCount: function () {
        const mainNavigationWidth = this.$mainNavigation.width();
        const logoWidth = this.$logo.outerWidth(true) || 150;

        const navigationWidth = mainNavigationWidth - logoWidth * 2;
        const moreItemWidth = this.$moreItem.outerWidth();
        const itemsNumber = this.navItemsMap.length;
        let menuItemsWidth = 0;
        let isFit = true;

        this.navItemsMap.forEach((el, index) => {
            if (isFit) {
                const itemWidth = $(el).outerWidth();

                if (menuItemsWidth + itemWidth + (index === itemsNumber - 1 ? 0 : moreItemWidth) <= navigationWidth) {
                    $(el).removeClass('is-hidden');
                    $(this.navMoreItemsMap[index]).addClass('is-hidden');

                    menuItemsWidth += itemWidth;

                } else {
                    $(el).addClass('is-hidden');
                    $(this.navMoreItemsMap[index]).removeClass('is-hidden');

                    isFit = false;
                }
            } else {
                $(el).addClass('is-hidden');
                $(this.navMoreItemsMap[index]).removeClass('is-hidden');
            }
        });

        this.$moreItem.toggleClass('is-hidden', isFit);
        this.$navigation.addClass('loaded');
        this.$navItemsWrapper.css({'max-width': navigationWidth - 10});
    },

    desktopEvents: (context) => {
        function shouldTriggerDropdown (event) {
            const $target = $(event.target);
            if (!$target.is('.s-dropdown, .s-dropdown *')) {
                if (event.type === 'touchend' && !$target.is('a, a * ')) {
                    event.preventDefault();
                }
                return true;
            }
            return false;
        }

        function openNavItem (el, event) {
            if (shouldTriggerDropdown(event)) {
                const targetIndex = $(el.context).data('index');
                context.itemClick(targetIndex);
            }
        }

        function openNavMoreItem (el, event) {
            if (shouldTriggerDropdown(event)) {
                context.expandedItemIndex != null && $(context.navItemsMap[context.expandedItemIndex]).removeClass('is-expanded');
                context.expandedItemIndex = null;
                context.$moreItem.toggleClass('is-expanded');
            }
        }

        return [{

            '.s-header .js-nav-item mouseenter': openNavItem,
            '.s-header .js-nav-item touchend': openNavItem,

            '.s-header .s-nav-item a.s-nav-title click': function (el) {
                const linkText = el.text().trim();
                dtm.trackGlobalNavigationSimpleLinkClick(linkText);
            },
            '.s-header .s-section--featured a click': function (el) {
                if (el.hasClass('s-card--promo')) {
                    dtm.trackGlobalNavigationPromoClick();
                } else {
                    dtm.trackGlobalNavigationFeatureClick();
                }
            },

            '.s-header .s-dropdown-content a click': function (el) {
                const content = el.closest('.s-dropdown-content');
                const sectionList = content.find('.s-section--list');
                const sectionListItem = el.closest('.s-section--list');
                const sectionLinks = sectionListItem.find('.s-list-item');
                const innerDropdownContent = el.closest('.s-inner-dropdown-content');
                const layout = content.data('layout');
                const linkName = el.text().trim().toLowerCase();

                let column = 1;
                let navigationPosition = '2nd';
                let linkPosition = sectionLinks.index(el) + 1;

                if (innerDropdownContent && innerDropdownContent.length) {
                    navigationPosition = '3rd';
                }

                if (layout === 'five-columns' || layout === 'four-columns') {
                    column = sectionList.index(sectionListItem) + 1;
                }

                if (linkPosition === 0) {
                    linkPosition = 1;
                }

                dtm.trackGlobalNavigationLinkClick(layout, column, navigationPosition, linkName, linkPosition);
            },

            '.s-header .js-nav-item mouseleave': function (el) {
                const targetIndex = $(el.context).data('index');
                context.itemClick(targetIndex);
            },

            '.s-header .js-nav-item-more mouseenter': openNavMoreItem,
            '.s-header .js-nav-item-more touchend': openNavMoreItem,

            '.s-header  .js-nav-item-more mouseleave': function (el) {
                context.expandedItemIndex != null && $(context.navItemsMap[context.expandedItemIndex]).removeClass('is-expanded');
                context.expandedItemIndex = null;
                context.$moreItem.removeClass('is-expanded');
            },

            '.s-header .js-dropdown-title.js-more-item click': function (el) {
                const targetIndex = $(el.context).data('index');
                context.itemClick(targetIndex);
            },

            '{document.body} touchstart': function (el, event) {
                // close dropdowns for tablets
                if (!$.contains(context.$navigation.get(0), event.target)) {
                    context.expandedItemIndex != null && $(context.navItemsMap[context.expandedItemIndex]).removeClass('is-expanded');
                    context.expandedItemIndex = null;
                    context.$moreItem.removeClass('is-expanded');
                }
            }
        }]
    },

    mobileEvents: (context) => [{

        '.s-header .js-dropdown-title click': function (el) {
            const targetIndex = $(el.context).closest('.js-nav-item').data('index');
            context.itemClick(targetIndex);
        },

        '.s-header .s-nav-item a.s-nav-title click': function (el) {
            const linkText = el.text().trim();
            dtm.trackGlobalNavigationSimpleLinkClick(linkText);
        },

        '.s-header .js-back-btn click': function (el) {
            const targetIndex = $(el.context).closest('.js-nav-item').data('index');
            context.itemClick(targetIndex);
        },

        '.s-header .js-inner-dropdown-title click': function (el) {
            const target = $(el.context).closest('.js-inner-item');
            target.addClass('is-expanded');
        },

        '.s-header .js-inner-back-btn click': function (el) {
            const target = $(el.context).closest('.js-inner-item');
            target.removeClass('is-expanded');
        },

        '.s-header .js-autorisation-title click': function (el) {
            const target = $(el.context).closest('.js-nav-item-autorisation');
            target.addClass('is-expanded');
        },

        '.s-header .js-autorisation-back click': function (el) {
            const target = $(el.context).closest('.js-nav-item-autorisation');
            target.removeClass('is-expanded');
        },

        '.s-header .js-hamburger-btn click': function () {
            context.$header.toggleClass('is-expanded', true);
            appContext.model.dispatch('page-scroll-toggle', [true]);
        },

        '.s-header .js-overlapping, .s-header .js-hamburger-close click': function () {
            context.$header.toggleClass('is-expanded', false);
            appContext.model.dispatch('page-scroll-toggle', [false]);

            if (context.expandedItemIndex != null) {
                context.itemClick(context.expandedItemIndex);
            }
        },
    }],

    itemClick: function (targetIndex) {
        $(this.navItemsMap[targetIndex]).toggleClass('is-expanded');
        this.expandedItemIndex != null && targetIndex != this.expandedItemIndex && $(this.navItemsMap[this.expandedItemIndex]).removeClass('is-expanded');
        this.expandedItemIndex = this.expandedItemIndex === targetIndex ? null : targetIndex;
        this.$moreItem.removeClass('is-expanded');
    },

    onWindowScroll: function () {
        this.$element.attr('data-is-scrolling', true)
    },
});
